import { render, staticRenderFns } from "./chartFailure.vue?vue&type=template&id=58b9e48e&"
import script from "./chartFailure.vue?vue&type=script&lang=js&"
export * from "./chartFailure.vue?vue&type=script&lang=js&"
import style0 from "./chartFailure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports